/**
 * Ad Event Types (matches backend EventType enum)
 */
export var AdEventType;
(function (AdEventType) {
    AdEventType["AD_REQUESTED"] = "ad_requested";
    AdEventType["AD_LOADED"] = "ad_loaded";
    AdEventType["AD_STARTED"] = "ad_started";
    AdEventType["AD_IMPRESSION"] = "ad_impression";
    AdEventType["AD_CLICKED"] = "ad_clicked";
    AdEventType["AD_COMPLETED"] = "ad_completed";
    AdEventType["AD_CLOSED"] = "ad_closed";
    AdEventType["AD_ERROR"] = "ad_error";
    AdEventType["AD_REWARDED"] = "ad_rewarded";
    AdEventType["REWARDED_STARTED"] = "rewarded_started";
    AdEventType["REWARDED_COMPLETED"] = "rewarded_completed";
    AdEventType["REWARDED_FAILED"] = "rewarded_failed";
    // Emitted when SDK-side pacing blocks an interstitial show. Carries
    // { reason: 'warmup'|'min_interval'|'hourly_cap', placement, adType }.
    AdEventType["AD_SUPPRESSED"] = "ad_suppressed";
})(AdEventType || (AdEventType = {}));
